import { render, staticRenderFns } from "./ConfiguredTextAreaDrawer.vue?vue&type=template&id=6cafd27c&"
import script from "./ConfiguredTextAreaDrawer.vue?vue&type=script&lang=ts&"
export * from "./ConfiguredTextAreaDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports